var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.162 9c0 .337-.112.675-.365.956l-7.088 7.538a.52.52 0 0 1-.703.028.52.52 0 0 1-.028-.703L8.066 9.28c.14-.14.14-.394 0-.562L.978 1.18C.781.984.81.675 1.006.478c.197-.197.506-.169.703.028l7.06 7.538c.253.28.393.618.393.956Z",
    fill: "#163144"
  })));
};
export default SvgArrowRight;